/** Sent on login so the API can reject non-platform accounts. */
export const AUTH_CLIENT_SOURCE = 'admin_web' as const;
